module.exports = __webpack_public_path__ + "images/jumpin_jack.f23ff34febb9cad7362902577f900f2a.png";